import React from 'react';

interface BookIconProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

export default function BookIcon({ className, size = 'large' }: BookIconProps) {
  return (
    <svg
      width={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
      height={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        minWidth: size === 'small' ? '16' : size === 'medium' ? '20' : '24',
        minHeight: size === 'small' ? '16' : size === 'medium' ? '20' : '24',
      }}
    >
      <path
        d="M3.33301 13.0001V4.13346C3.33301 3.38673 3.33301 3.01308 3.47833 2.72786C3.60616 2.47698 3.80999 2.27316 4.06087 2.14532C4.34609 2 4.71973 2 5.46647 2H11.5998C11.9732 2 12.1601 2 12.3027 2.07266C12.4282 2.13658 12.5295 2.23849 12.5934 2.36393C12.6661 2.50654 12.6663 2.69336 12.6663 3.06673V10.9334C12.6663 11.3068 12.6661 11.4932 12.5934 11.6358C12.5295 11.7612 12.4283 11.8635 12.3029 11.9274C12.1604 12 11.9737 12 11.601 12H4.83301C4.00458 12 3.33301 12.6716 3.33301 13.5C3.33301 13.7761 3.55687 14 3.83301 14H10.9344C11.307 14 11.4937 14 11.6362 13.9274C11.7616 13.8635 11.8628 13.7613 11.9268 13.6359C11.9994 13.4933 11.9997 13.3067 11.9997 12.9333V12"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
